import React, { useState, useEffect } from "react";

const DropZone = ({ className = "", multiple = false, accepts = null, alert = null, onAdd, forceReset }) => {
	const [files, setFiles] = useState([]);
	const [dragOver, setDragOver] = useState(false);

	useEffect(() => {
		onAdd(files);
	}, [files, onAdd]);

	useEffect(() => {
		forceReset && setFiles([]);
	}, [forceReset]);

	const onDragOver = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setDragOver(true);
	};

	const onDragLeave = (event) => {
		event.preventDefault();
		event.stopPropagation();
		setDragOver(false);
	};

	const onDrop = (event) => {
		event.preventDefault();
		setDragOver(false);
		addFilesToList([...event.nativeEvent.dataTransfer.files]);
	};

	const onFileChange = (event) => {
		event.preventDefault();
		addFilesToList([...event.target.files]);
		event.target.value = null;
	};

	const addFilesToList = (newFiles) => {
		const uploadedFiles = newFiles.filter((item) => {
			const isExist = files.filter(({ file }) => {
				return item.name === file.name && item.size === file.size;
			});
			const extension = item.type.split("/")[1];
			const acceptable = accepts ? accepts.indexOf(extension) > -1 : true;
			!acceptable && alert && alert({ type: "error", text: `Unsupported format! (${extension})` });
			return acceptable && isExist.length === 0;
		});
		const fieldFiles = uploadedFiles.map((file) => ({ file, dataURL: null }));
		if (multiple) {
			setFiles((prevState) => [...prevState, ...fieldFiles]);
		} else {
			fieldFiles[0] && setFiles([fieldFiles[0]]);
		}
	};

	useEffect(() => {
		const listItem = files.filter((item) => !item.dataURL)[0];
		if (listItem) {
			const reader = new FileReader();
			reader.onload = () => {
				const newFiles = files.map((innItem) => {
					if (!innItem.dataURL && listItem.file === innItem.file) {
						return { ...innItem, dataURL: reader.result };
					}
					return innItem;
				});
				setFiles(newFiles);
			};
			reader.readAsDataURL(listItem.file);
		}
	}, [files]);

	const removeFile = (file) => {
		setFiles(files.filter((item) => item !== file));
	};

	return (
		<div className={`dropzone-wrap ${className}`}>
			<div
				onDragOver={onDragOver}
				onDragLeave={onDragLeave}
				onDrop={onDrop}
				className={`dropzone ${dragOver ? "drag-over" : ""}`}>
				<div className="dropzone-files-wrap">
					<label className="dropzone-input-label">
						<div className="dropzone-label">
							<i className="icon icon-picture" />
							<h4>Drag an image here</h4>
							<div>or</div>
						</div>
						<div className="dropzone-btn">Select a photo from your computer</div>
						<input
							type="file"
							className="form-control dropzone-input"
							onChange={onFileChange}
							multiple={multiple}
						/>
					</label>
					<div className="dropzone-files">
						{files.map((item, index) => {
							const { file, dataURL } = item;
							return (
								<div className="dropzone-file" key={index}>
									{dataURL && <img className="dropzone-thumbnail" src={dataURL} alt={file.name} />}
									<div className="dropzone-file-name">{file.name}</div>
									<div className="dropzone-file-remove" onClick={() => removeFile(item)}>
										+
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default DropZone;
